/**
 * CORE-1904 — шрифты иконок на вебе грузим сами и с обработкой отказа.
 *
 * `@expo/vector-icons` грузит шрифт иконки в `async componentDidMount()`:
 * `await Font.loadAsync(font)` без try/catch, а React промис из
 * componentDidMount не ждёт. На вебе `expo-font` ждёт шрифт через
 * FontFaceObserver с таймаутом 6000 мс; когда шрифт не успел (медленная сеть,
 * headless-браузер), отказ «6000ms timeout exceeded» уходит в
 * `unhandledrejection` — по одному на каждую иконку первого кадра
 * (GlitchTip FRONTEND-17).
 *
 * Если вызвать `Font.loadAsync` для шрифтов иконок раньше первого рендера,
 * `expo-font` синхронно вставляет @font-face, `Font.isLoaded()` становится
 * true, и иконки свой `loadAsync` уже не вызывают. Отказ остаётся только у
 * нашего промиса — здесь он и гасится: @font-face уже в документе, браузер
 * применит шрифт, когда тот догрузится, рендер ничего не ждёт.
 *
 * Модуль без импорта `expo-font` (ESM ломает jest) — загрузчик передаётся.
 */
export type LoadFonts = (fontMap: Record<string, any>) => Promise<void>;

export function preloadIconFonts(
  load: LoadFonts,
  fontMap: Record<string, any>,
): Promise<void> {
  try {
    return Promise.resolve(load(fontMap)).catch(() => undefined);
  } catch {
    return Promise.resolve();
  }
}
